define('plugin/membership/model/MembershipPaymentModel',['require','lib/model/BaseModel','plugin/invoice/model/InvoiceModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');
    var InvoiceModel = require('plugin/invoice/model/InvoiceModel');

    /**
     * Cart data model
     *
     * @class CartModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/membership/client/id/',

        defaults: {
            id: null,
            invoice: null,
            plugin_membership_id: null,
            period_start: null,
            period_end: null
        },

        parse: function (resp, options) {
            var result = BaseModel.prototype.parse.apply(this, [resp, options]);
            if (result.invoice) {
                result.invoice = new InvoiceModel(result.invoice);
            }

            return result;
        }

    });

});
